import { createI18n } from 'vue-i18n'
import { detectLocale } from './detect'

export { detectLocale } from './detect'

export const SUPPORTED_LOCALES = ['en', 'de', 'pt', 'es', 'fr', 'tr'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]

// Detect the initial locale at module load time so the i18n instance starts
// with the correct locale before any messages are loaded.
const initialLocale: SupportedLocale = detectLocale()

export const i18n = createI18n({
    legacy: false,
    locale: initialLocale,
    fallbackLocale: 'en',
    messages: {},
    missingWarn: import.meta.env.DEV,
})

const loadedLocales: Set<string> = new Set()

export async function loadLocaleMessages(locale: SupportedLocale): Promise<void> {
    if (loadedLocales.has(locale)) {
        return
    }

    const messages = await import(`./locales/${locale}.json`)
    i18n.global.setLocaleMessage(locale, messages.default)
    loadedLocales.add(locale)
}

export async function setLocale(locale: SupportedLocale): Promise<void> {
    await loadLocaleMessages(locale)
    i18n.global.locale.value = locale
    localStorage.setItem('locale', locale)
}
